import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { usePortal, API_BASE } from './HousePortalLayout';

// ═══════════════════════════════════════════════════════════
// Translation strings
// ═══════════════════════════════════════════════════════════
const T = {
  en: {
    heroTitle: 'Find Your Dream Home in Bangkok',
    heroSub: 'AI-Powered Luxury Property Search',
    explore: 'Explore Properties',
    searchPlaceholder: 'Search by location, project, or keyword...',
    aiTitle: 'Meet Your AI Property Concierge',
    aiDesc: 'Our AI assistant is available 24/7 to help you find the perfect property. Get personalized recommendations, neighborhood insights, and expert guidance in seconds.',
    aiCta: 'Tell me what you\'re looking for',
    featured: 'Featured Properties',
    viewAll: 'View All',
    viewDetails: 'View Details',
    beds: 'Beds',
    baths: 'Baths',
    howTitle: 'How It Works',
    step1t: 'Tell AI Your Preferences',
    step1d: 'Describe your ideal property, budget, and lifestyle. Our AI understands natural language in 15 languages.',
    step2t: 'Get Matched Properties',
    step2d: 'Receive curated listings that match your criteria, with AI-powered insights on each property.',
    step3t: 'Virtual Tour & Chat',
    step3d: 'Explore properties through immersive virtual tours and ask our AI any questions in real-time.',
    step4t: 'AI-Assisted Close',
    step4d: 'Get help with negotiations, paperwork, and the entire closing process with AI guidance.',
    statsProperties: 'Properties',
    statsClients: 'Happy Clients',
    statsSupport: 'AI Support',
    statsLang: 'Languages',
    testTitle: 'What Our Clients Say',
    ctaTitle: 'Ready to Find Your Home?',
    ctaSub: 'Leave your details and our team will get back to you within 24 hours.',
    name: 'Full Name',
    email: 'Email Address',
    phone: 'Phone Number',
    message: 'Tell us what you\'re looking for...',
    submit: 'Send Inquiry',
    budget: 'Budget',
    bedrooms: 'Bedrooms',
    location: 'Location',
    any: 'Any',
    allLocations: 'All Locations',
    hot: 'HOT',
    sqm: 'sqm',
  },
  th: {
    heroTitle: '\u0e04\u0e49\u0e19\u0e2b\u0e32\u0e1a\u0e49\u0e32\u0e19\u0e43\u0e19\u0e1d\u0e31\u0e19\u0e02\u0e2d\u0e07\u0e04\u0e38\u0e13\u0e43\u0e19\u0e01\u0e23\u0e38\u0e07\u0e40\u0e17\u0e1e',
    heroSub: '\u0e04\u0e49\u0e19\u0e2b\u0e32\u0e2d\u0e2a\u0e31\u0e07\u0e2b\u0e32\u0e23\u0e34\u0e21\u0e17\u0e23\u0e31\u0e1e\u0e22\u0e4c\u0e2b\u0e23\u0e39\u0e2b\u0e23\u0e32\u0e14\u0e49\u0e27\u0e22 AI',
    explore: '\u0e2a\u0e33\u0e23\u0e27\u0e08\u0e2d\u0e2a\u0e31\u0e07\u0e2b\u0e32\u0e23\u0e34\u0e21\u0e17\u0e23\u0e31\u0e1e\u0e22\u0e4c',
    searchPlaceholder: '\u0e04\u0e49\u0e19\u0e2b\u0e32\u0e15\u0e32\u0e21\u0e17\u0e33\u0e40\u0e25\u0e2d\u0e32\u0e17\u0e35\u0e48 \u0e42\u0e04\u0e23\u0e07\u0e01\u0e32\u0e23...',
    aiTitle: '\u0e1e\u0e1a AI \u0e17\u0e35\u0e48\u0e1b\u0e23\u0e36\u0e01\u0e29\u0e32\u0e02\u0e2d\u0e07\u0e04\u0e38\u0e13',
    aiDesc: 'AI \u0e1e\u0e23\u0e49\u0e2d\u0e21\u0e43\u0e2b\u0e49\u0e1a\u0e23\u0e34\u0e01\u0e32\u0e23 24/7 \u0e40\u0e1e\u0e37\u0e48\u0e2d\u0e0a\u0e48\u0e27\u0e22\u0e04\u0e38\u0e13\u0e2b\u0e32\u0e2d\u0e2a\u0e31\u0e07\u0e2b\u0e32\u0e23\u0e34\u0e21\u0e17\u0e23\u0e31\u0e1e\u0e22\u0e4c\u0e17\u0e35\u0e48\u0e2a\u0e21\u0e1a\u0e39\u0e23\u0e13\u0e4c\u0e41\u0e1a\u0e1a',
    aiCta: '\u0e1a\u0e2d\u0e01\u0e2a\u0e34\u0e48\u0e07\u0e17\u0e35\u0e48\u0e04\u0e38\u0e13\u0e01\u0e33\u0e25\u0e31\u0e07\u0e21\u0e2d\u0e07\u0e2b\u0e32',
    featured: '\u0e2d\u0e2a\u0e31\u0e07\u0e2b\u0e32\u0e23\u0e34\u0e21\u0e17\u0e23\u0e31\u0e1e\u0e22\u0e4c\u0e41\u0e19\u0e30\u0e19\u0e33',
    viewAll: '\u0e14\u0e39\u0e17\u0e31\u0e49\u0e07\u0e2b\u0e21\u0e14',
    viewDetails: '\u0e14\u0e39\u0e23\u0e32\u0e22\u0e25\u0e30\u0e40\u0e2d\u0e35\u0e22\u0e14',
    beds: '\u0e2b\u0e49\u0e2d\u0e07\u0e19\u0e2d\u0e19',
    baths: '\u0e2b\u0e49\u0e2d\u0e07\u0e19\u0e49\u0e33',
    howTitle: '\u0e02\u0e31\u0e49\u0e19\u0e15\u0e2d\u0e19\u0e01\u0e32\u0e23\u0e17\u0e33\u0e07\u0e32\u0e19',
    step1t: '\u0e1a\u0e2d\u0e01 AI \u0e15\u0e32\u0e21\u0e04\u0e27\u0e32\u0e21\u0e15\u0e49\u0e2d\u0e07\u0e01\u0e32\u0e23',
    step1d: '\u0e2d\u0e18\u0e34\u0e1a\u0e32\u0e22\u0e2d\u0e2a\u0e31\u0e07\u0e2b\u0e32\u0e23\u0e34\u0e21\u0e17\u0e23\u0e31\u0e1e\u0e22\u0e4c\u0e43\u0e19\u0e2d\u0e38\u0e14\u0e21\u0e04\u0e15\u0e34 \u0e07\u0e1a\u0e1b\u0e23\u0e30\u0e21\u0e32\u0e13 \u0e41\u0e25\u0e30\u0e44\u0e25\u0e1f\u0e4c\u0e2a\u0e44\u0e15\u0e25\u0e4c',
    step2t: '\u0e23\u0e31\u0e1a\u0e23\u0e32\u0e22\u0e01\u0e32\u0e23\u0e17\u0e35\u0e48\u0e15\u0e23\u0e07',
    step2d: '\u0e23\u0e31\u0e1a\u0e23\u0e32\u0e22\u0e01\u0e32\u0e23\u0e17\u0e35\u0e48\u0e04\u0e31\u0e14\u0e40\u0e25\u0e37\u0e2d\u0e01\u0e41\u0e25\u0e49\u0e27\u0e15\u0e23\u0e07\u0e01\u0e31\u0e1a\u0e40\u0e01\u0e13\u0e11\u0e4c\u0e02\u0e2d\u0e07\u0e04\u0e38\u0e13',
    step3t: '\u0e17\u0e31\u0e27\u0e23\u0e4c\u0e40\u0e2a\u0e21\u0e37\u0e2d\u0e19\u0e08\u0e23\u0e34\u0e07\u0e41\u0e25\u0e30\u0e41\u0e0a\u0e17',
    step3d: '\u0e2a\u0e33\u0e23\u0e27\u0e08\u0e2d\u0e2a\u0e31\u0e07\u0e2b\u0e32\u0e23\u0e34\u0e21\u0e17\u0e23\u0e31\u0e1e\u0e22\u0e4c\u0e1c\u0e48\u0e32\u0e19\u0e17\u0e31\u0e27\u0e23\u0e4c\u0e40\u0e2a\u0e21\u0e37\u0e2d\u0e19\u0e08\u0e23\u0e34\u0e07',
    step4t: '\u0e1b\u0e34\u0e14\u0e14\u0e35\u0e25\u0e14\u0e49\u0e27\u0e22 AI',
    step4d: '\u0e23\u0e31\u0e1a\u0e04\u0e27\u0e32\u0e21\u0e0a\u0e48\u0e27\u0e22\u0e40\u0e2b\u0e25\u0e37\u0e2d\u0e43\u0e19\u0e01\u0e32\u0e23\u0e40\u0e08\u0e23\u0e08\u0e32 \u0e40\u0e2d\u0e01\u0e2a\u0e32\u0e23 \u0e41\u0e25\u0e30\u0e01\u0e32\u0e23\u0e1b\u0e34\u0e14\u0e14\u0e35\u0e25',
    statsProperties: '\u0e2d\u0e2a\u0e31\u0e07\u0e2b\u0e32\u0e23\u0e34\u0e21\u0e17\u0e23\u0e31\u0e1e\u0e22\u0e4c',
    statsClients: '\u0e25\u0e39\u0e01\u0e04\u0e49\u0e32\u0e17\u0e35\u0e48\u0e1e\u0e36\u0e07\u0e1e\u0e2d\u0e43\u0e08',
    statsSupport: 'AI \u0e0a\u0e48\u0e27\u0e22\u0e40\u0e2b\u0e25\u0e37\u0e2d',
    statsLang: '\u0e20\u0e32\u0e29\u0e32',
    testTitle: '\u0e25\u0e39\u0e01\u0e04\u0e49\u0e32\u0e02\u0e2d\u0e07\u0e40\u0e23\u0e32\u0e1e\u0e39\u0e14\u0e16\u0e36\u0e07\u0e40\u0e23\u0e32',
    ctaTitle: '\u0e1e\u0e23\u0e49\u0e2d\u0e21\u0e2b\u0e32\u0e1a\u0e49\u0e32\u0e19\u0e43\u0e2b\u0e21\u0e48\u0e2b\u0e23\u0e37\u0e2d\u0e22\u0e31\u0e07?',
    ctaSub: '\u0e17\u0e34\u0e49\u0e07\u0e02\u0e49\u0e2d\u0e21\u0e39\u0e25\u0e44\u0e27\u0e49 \u0e17\u0e35\u0e21\u0e07\u0e32\u0e19\u0e08\u0e30\u0e15\u0e34\u0e14\u0e15\u0e48\u0e2d\u0e01\u0e25\u0e31\u0e1a\u0e20\u0e32\u0e22\u0e43\u0e19 24 \u0e0a\u0e31\u0e48\u0e27\u0e42\u0e21\u0e07',
    name: '\u0e0a\u0e37\u0e48\u0e2d\u0e40\u0e15\u0e47\u0e21',
    email: '\u0e2d\u0e35\u0e40\u0e21\u0e25',
    phone: '\u0e40\u0e1a\u0e2d\u0e23\u0e4c\u0e42\u0e17\u0e23\u0e28\u0e31\u0e1e\u0e17\u0e4c',
    message: '\u0e1a\u0e2d\u0e01\u0e2a\u0e34\u0e48\u0e07\u0e17\u0e35\u0e48\u0e04\u0e38\u0e13\u0e01\u0e33\u0e25\u0e31\u0e07\u0e21\u0e2d\u0e07\u0e2b\u0e32...',
    submit: '\u0e2a\u0e48\u0e07\u0e04\u0e33\u0e23\u0e49\u0e2d\u0e07\u0e02\u0e2d',
    budget: '\u0e07\u0e1a\u0e1b\u0e23\u0e30\u0e21\u0e32\u0e13',
    bedrooms: '\u0e2b\u0e49\u0e2d\u0e07\u0e19\u0e2d\u0e19',
    location: '\u0e17\u0e33\u0e40\u0e25',
    any: '\u0e17\u0e31\u0e49\u0e07\u0e2b\u0e21\u0e14',
    allLocations: '\u0e17\u0e38\u0e01\u0e17\u0e33\u0e40\u0e25',
    hot: 'HOT',
    sqm: '\u0e15\u0e23.\u0e21.',
  },
  zh: {
    heroTitle: '\u5728\u66fc\u8c37\u627e\u5230\u60a8\u7684\u5922\u60f3\u5bb6\u5712',
    heroSub: 'AI \u9a45\u52d5\u7684\u8c6a\u83ef\u623f\u7522\u641c\u5c0b',
    explore: '\u63a2\u7d22\u623f\u7522',
    searchPlaceholder: '\u6309\u4f4d\u7f6e\u3001\u9805\u76ee\u6216\u95dc\u9375\u5b57\u641c\u5c0b...',
    aiTitle: '\u8a8d\u8b58\u60a8\u7684 AI \u623f\u7522\u7ba1\u5bb6',
    aiDesc: '\u6211\u5011\u7684 AI \u52a9\u624b\u5168\u5929\u5019 24/7 \u70ba\u60a8\u670d\u52d9\u3002\u7372\u53d6\u500b\u6027\u5316\u63a8\u85a6\u3001\u793e\u5340\u6d1e\u5bdf\u548c\u5c08\u5bb6\u6307\u5c0e\u3002',
    aiCta: '\u544a\u8a34\u6211\u60a8\u5728\u627e\u4ec0\u9ebc',
    featured: '\u7cbe\u9078\u623f\u7522',
    viewAll: '\u67e5\u770b\u5168\u90e8',
    viewDetails: '\u67e5\u770b\u8a73\u60c5',
    beds: '\u81e5\u5ba4',
    baths: '\u6d74\u5ba4',
    howTitle: '\u5982\u4f55\u904b\u4f5c',
    step1t: '\u544a\u8a34 AI \u60a8\u7684\u504f\u597d',
    step1d: '\u63cf\u8ff0\u60a8\u7406\u60f3\u7684\u623f\u7522\u3001\u9810\u7b97\u548c\u751f\u6d3b\u65b9\u5f0f\u3002',
    step2t: '\u7372\u53d6\u5339\u914d\u623f\u7522',
    step2d: '\u63a5\u6536\u7b26\u5408\u60a8\u6a19\u6e96\u7684\u7cbe\u9078\u623f\u7522\u5217\u8868\u3002',
    step3t: '\u865b\u64ec\u5c0e\u89bd\u8207\u54a8\u8a62',
    step3d: '\u901a\u904e\u6c89\u6d78\u5f0f\u865b\u64ec\u5c0e\u89bd\u63a2\u7d22\u623f\u7522\u3002',
    step4t: 'AI \u5354\u52a9\u6210\u4ea4',
    step4d: '\u7372\u53d6\u8ac7\u5224\u3001\u6587\u4ef6\u548c\u6574\u500b\u6210\u4ea4\u904e\u7a0b\u7684\u5e6b\u52a9\u3002',
    statsProperties: '\u623f\u7522',
    statsClients: '\u6eff\u610f\u5ba2\u6236',
    statsSupport: 'AI \u652f\u63f4',
    statsLang: '\u8a9e\u8a00',
    testTitle: '\u5ba2\u6236\u8a55\u50f9',
    ctaTitle: '\u6e96\u5099\u597d\u627e\u5230\u60a8\u7684\u5bb6\u4e86\u55ce\uff1f',
    ctaSub: '\u7559\u4e0b\u60a8\u7684\u8a73\u7d30\u4fe1\u606f\uff0c\u6211\u5011\u7684\u5718\u968a\u5c07\u5728 24 \u5c0f\u6642\u5167\u56de\u8986\u60a8\u3002',
    name: '\u59d3\u540d',
    email: '\u96fb\u5b50\u90f5\u4ef6',
    phone: '\u96fb\u8a71\u865f\u78bc',
    message: '\u544a\u8a34\u6211\u5011\u60a8\u5728\u627e\u4ec0\u9ebc...',
    submit: '\u63d0\u4ea4\u8a62\u554f',
    budget: '\u9810\u7b97',
    bedrooms: '\u81e5\u5ba4',
    location: '\u4f4d\u7f6e',
    any: '\u4efb\u610f',
    allLocations: '\u6240\u6709\u4f4d\u7f6e',
    hot: 'HOT',
    sqm: '\u5e73\u65b9\u7c73',
  },
};

// ═══════════════════════════════════════════════════════════
// Mock data for when API not available
// ═══════════════════════════════════════════════════════════
const MOCK_PROPERTIES = [
  { id: 1, title: 'The Residences at Mandarin Oriental', location: 'Riverside', district: 'Charoenkrung', price: 45000000, currency: 'THB', bedrooms: 3, bathrooms: 3, area_sqm: 265, is_featured: true, type: 'Condo', gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' },
  { id: 2, title: 'Park Origin Thonglor', location: 'Thonglor', district: 'Sukhumvit', price: 18500000, currency: 'THB', bedrooms: 2, bathrooms: 2, area_sqm: 87, is_featured: true, type: 'Condo', gradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)' },
  { id: 3, title: 'Muniq Sukhumvit 23', location: 'Asok', district: 'Sukhumvit', price: 22000000, currency: 'THB', bedrooms: 2, bathrooms: 2, area_sqm: 110, is_featured: false, type: 'Condo', gradient: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)' },
  { id: 4, title: 'The Diplomat Sathorn', location: 'Sathorn', district: 'Sathorn', price: 38000000, currency: 'THB', bedrooms: 3, bathrooms: 3, area_sqm: 198, is_featured: true, type: 'Condo', gradient: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)' },
  { id: 5, title: 'Baan Sansiri Pattanakarn', location: 'Pattanakarn', district: 'Suan Luang', price: 65000000, currency: 'THB', bedrooms: 4, bathrooms: 5, area_sqm: 420, is_featured: true, type: 'House', gradient: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)' },
  { id: 6, title: 'Khun by Yoo', location: 'Thonglor', district: 'Sukhumvit', price: 29000000, currency: 'THB', bedrooms: 2, bathrooms: 2, area_sqm: 125, is_featured: true, type: 'Condo', gradient: 'linear-gradient(135deg, #a18cd1 0%, #fbc2eb 100%)' },
];

const TESTIMONIALS = [
  { name: 'James Morrison', role: 'British Expat, Investor', text: 'HOUSE AI found me the perfect Sukhumvit condo in 48 hours. The AI concierge understood exactly what I wanted and the virtual tours saved me multiple trips.', rating: 5 },
  { name: 'Yuki Tanaka', role: 'Japanese Executive', text: 'Moving to Bangkok was seamless with HOUSE AI. The multilingual support and AI recommendations were incredibly accurate. Found my dream penthouse in Thonglor!', rating: 5 },
  { name: 'Sarah Chen', role: 'Singaporean Entrepreneur', text: 'I was amazed by how the AI analyzed market data and helped me negotiate a great price. Best real estate experience I\'ve ever had, hands down.', rating: 5 },
];

const LOCATIONS = ['All Locations', 'Sukhumvit', 'Thonglor', 'Ekkamai', 'Sathorn', 'Silom', 'Riverside', 'Ari', 'Ratchada'];

// ═══════════════════════════════════════════════════════════
// AnimatedCounter Component
// ═══════════════════════════════════════════════════════════
function AnimatedCounter({ end, suffix, duration = 2000 }) {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const hasAnimated = useRef(false);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting && !hasAnimated.current) {
        hasAnimated.current = true;
        const start = 0;
        const startTime = Date.now();
        const animate = () => {
          const elapsed = Date.now() - startTime;
          const progress = Math.min(elapsed / duration, 1);
          const eased = 1 - Math.pow(1 - progress, 3);
          setCount(Math.floor(start + (end - start) * eased));
          if (progress < 1) requestAnimationFrame(animate);
        };
        animate();
      }
    }, { threshold: 0.3 });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [end, duration]);

  return <span ref={ref}>{count.toLocaleString()}{suffix}</span>;
}

// ═══════════════════════════════════════════════════════════
// Main Home Component
// ═══════════════════════════════════════════════════════════
export default function HousePortalHome() {
  const { slug, lang, isMobile, portalInfo } = usePortal();
  const navigate = useNavigate();
  const t = T[lang] || T.en;

  const [properties, setProperties] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [budget, setBudget] = useState('');
  const [bedrooms, setBedrooms] = useState('');
  const [searchLocation, setSearchLocation] = useState('');
  const [formData, setFormData] = useState({ name: '', email: '', phone: '', message: '' });
  const [formSubmitted, setFormSubmitted] = useState(false);

  // Fetch featured properties
  useEffect(() => {
    const fetchProps = async () => {
      try {
        const res = await fetch(`${API_BASE}/h/${slug}/properties?featured=true&limit=6`);
        if (res.ok) {
          const data = await res.json();
          setProperties(data.items || data.properties || data || []);
        } else {
          setProperties(MOCK_PROPERTIES);
        }
      } catch {
        setProperties(MOCK_PROPERTIES);
      }
    };
    fetchProps();
  }, [slug]);

  const displayProperties = properties.length > 0 ? properties : MOCK_PROPERTIES;

  const formatPrice = (price, currency = 'THB') => {
    if (price >= 1000000) return `${currency} ${(price / 1000000).toFixed(1)}M`;
    if (price >= 1000) return `${currency} ${(price / 1000).toFixed(0)}K`;
    return `${currency} ${price}`;
  };

  const handleSearch = () => {
    const params = new URLSearchParams();
    if (searchQuery) params.set('q', searchQuery);
    if (budget) params.set('budget', budget);
    if (bedrooms) params.set('bedrooms', bedrooms);
    if (searchLocation && searchLocation !== 'All Locations') params.set('district', searchLocation);
    navigate(`/h/${slug}/properties?${params.toString()}`);
  };

  const handleFormSubmit = async () => {
    try {
      await fetch(`${API_BASE}/h/${slug}/inquiries`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });
    } catch { /* fallthrough */ }
    setFormSubmitted(true);
    setTimeout(() => setFormSubmitted(false), 3000);
    setFormData({ name: '', email: '', phone: '', message: '' });
  };

  const gradients = [
    'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
    'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
    'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)',
    'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
    'linear-gradient(135deg, #a18cd1 0%, #fbc2eb 100%)',
  ];

  return (
    <div style={{ overflow: 'hidden' }}>

      {/* ═══ HERO SECTION ═══ */}
      <section style={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 30%, #0f3460 60%, #1a1a2e 100%)',
        backgroundSize: '400% 400%',
        animation: 'houseGradient 15s ease infinite',
        display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center',
        position: 'relative',
        padding: isMobile ? '80px 24px 60px' : '120px 48px 80px',
      }}>
        {/* Decorative Elements */}
        <div style={{
          position: 'absolute', top: '15%', left: '10%',
          width: 200, height: 200, borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(212,165,55,0.08) 0%, transparent 70%)',
          filter: 'blur(40px)',
        }} />
        <div style={{
          position: 'absolute', bottom: '20%', right: '15%',
          width: 300, height: 300, borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(232,54,58,0.06) 0%, transparent 70%)',
          filter: 'blur(60px)',
        }} />

        {/* Grid pattern overlay */}
        <div style={{
          position: 'absolute', inset: 0,
          backgroundImage: 'radial-gradient(rgba(255,255,255,0.03) 1px, transparent 1px)',
          backgroundSize: '40px 40px',
        }} />

        <div style={{ position: 'relative', zIndex: 1, textAlign: 'center', maxWidth: 800, width: '100%' }}>
          {/* Badge */}
          <div style={{
            display: 'inline-flex', alignItems: 'center', gap: 8,
            background: 'rgba(212,165,55,0.12)', border: '1px solid rgba(212,165,55,0.25)',
            borderRadius: 24, padding: '8px 20px', marginBottom: 28,
            animation: 'houseFadeIn 0.6s ease',
          }}>
            <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#d4a537', display: 'inline-block', animation: 'housePulse 2s ease infinite' }} />
            <span style={{ color: '#d4a537', fontSize: 13, fontWeight: 500, letterSpacing: 1 }}>AI-POWERED PROPERTY SEARCH</span>
          </div>

          {/* Title */}
          <h1 style={{
            fontSize: isMobile ? 36 : 64,
            fontWeight: 800,
            color: '#fff',
            lineHeight: 1.1,
            marginBottom: 20,
            letterSpacing: -1.5,
            animation: 'houseFadeIn 0.8s ease',
          }}>
            {t.heroTitle}
          </h1>

          <p style={{
            fontSize: isMobile ? 18 : 22,
            color: 'rgba(255,255,255,0.6)',
            marginBottom: 48,
            fontWeight: 300,
            letterSpacing: 0.5,
            animation: 'houseFadeIn 1s ease',
          }}>
            {t.heroSub}
          </p>

          {/* Search Bar */}
          <div style={{
            background: 'rgba(255,255,255,0.08)',
            backdropFilter: 'blur(20px)', WebkitBackdropFilter: 'blur(20px)',
            borderRadius: 20,
            border: '1px solid rgba(255,255,255,0.1)',
            padding: isMobile ? 16 : 20,
            animation: 'houseFadeIn 1.2s ease',
            maxWidth: 720,
            margin: '0 auto',
          }}>
            {/* Main search input */}
            <div style={{ display: 'flex', gap: 12, marginBottom: 16 }}>
              <div style={{ flex: 1, position: 'relative' }}>
                <span style={{ position: 'absolute', left: 16, top: '50%', transform: 'translateY(-50%)', fontSize: 18, opacity: 0.5, color: '#fff' }}>&#128269;</span>
                <input
                  value={searchQuery}
                  onChange={e => setSearchQuery(e.target.value)}
                  onKeyDown={e => e.key === 'Enter' && handleSearch()}
                  placeholder={t.searchPlaceholder}
                  style={{
                    width: '100%',
                    padding: '14px 16px 14px 48px',
                    borderRadius: 14,
                    border: '1px solid rgba(255,255,255,0.1)',
                    background: 'rgba(255,255,255,0.06)',
                    color: '#fff',
                    fontSize: 16,
                    outline: 'none',
                    transition: 'border-color 0.3s',
                  }}
                  onFocus={e => e.target.style.borderColor = 'rgba(212,165,55,0.5)'}
                  onBlur={e => e.target.style.borderColor = 'rgba(255,255,255,0.1)'}
                />
              </div>
            </div>

            {/* Filter row */}
            <div style={{
              display: 'grid',
              gridTemplateColumns: isMobile ? '1fr 1fr' : '1fr 1fr 1fr auto',
              gap: 12,
            }}>
              <select
                value={budget}
                onChange={e => setBudget(e.target.value)}
                style={{
                  padding: '12px 16px', borderRadius: 12,
                  border: '1px solid rgba(255,255,255,0.1)',
                  background: 'rgba(255,255,255,0.06)',
                  color: '#fff', fontSize: 14, outline: 'none',
                  cursor: 'pointer', appearance: 'none',
                  WebkitAppearance: 'none',
                }}
              >
                <option value="" style={{ background: '#1a1a2e' }}>{t.budget}</option>
                <option value="0-10" style={{ background: '#1a1a2e' }}>Under 10M THB</option>
                <option value="10-20" style={{ background: '#1a1a2e' }}>10-20M THB</option>
                <option value="20-50" style={{ background: '#1a1a2e' }}>20-50M THB</option>
                <option value="50+" style={{ background: '#1a1a2e' }}>50M+ THB</option>
              </select>

              <select
                value={bedrooms}
                onChange={e => setBedrooms(e.target.value)}
                style={{
                  padding: '12px 16px', borderRadius: 12,
                  border: '1px solid rgba(255,255,255,0.1)',
                  background: 'rgba(255,255,255,0.06)',
                  color: '#fff', fontSize: 14, outline: 'none',
                  cursor: 'pointer', appearance: 'none',
                  WebkitAppearance: 'none',
                }}
              >
                <option value="" style={{ background: '#1a1a2e' }}>{t.bedrooms}</option>
                <option value="1" style={{ background: '#1a1a2e' }}>1 {t.beds}</option>
                <option value="2" style={{ background: '#1a1a2e' }}>2 {t.beds}</option>
                <option value="3" style={{ background: '#1a1a2e' }}>3 {t.beds}</option>
                <option value="4" style={{ background: '#1a1a2e' }}>4+ {t.beds}</option>
              </select>

              <select
                value={searchLocation}
                onChange={e => setSearchLocation(e.target.value)}
                style={{
                  padding: '12px 16px', borderRadius: 12,
                  border: '1px solid rgba(255,255,255,0.1)',
                  background: 'rgba(255,255,255,0.06)',
                  color: '#fff', fontSize: 14, outline: 'none',
                  cursor: 'pointer', appearance: 'none',
                  WebkitAppearance: 'none',
                }}
              >
                <option value="" style={{ background: '#1a1a2e' }}>{t.location}</option>
                {LOCATIONS.map(loc => (
                  <option key={loc} value={loc} style={{ background: '#1a1a2e' }}>{loc}</option>
                ))}
              </select>

              <button
                onClick={handleSearch}
                style={{
                  background: 'linear-gradient(135deg, #e8363a, #c02a2e)',
                  color: '#fff', border: 'none',
                  padding: isMobile ? '12px 24px' : '12px 32px',
                  borderRadius: 12, fontSize: 15, fontWeight: 600,
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  boxShadow: '0 4px 16px rgba(232,54,58,0.3)',
                  whiteSpace: 'nowrap',
                  gridColumn: isMobile ? '1 / -1' : 'auto',
                }}
                onMouseEnter={e => { e.target.style.transform = 'translateY(-2px)'; e.target.style.boxShadow = '0 8px 24px rgba(232,54,58,0.4)'; }}
                onMouseLeave={e => { e.target.style.transform = 'translateY(0)'; e.target.style.boxShadow = '0 4px 16px rgba(232,54,58,0.3)'; }}
              >
                {t.explore}
              </button>
            </div>
          </div>

          {/* Scroll indicator */}
          <div style={{
            marginTop: 64, opacity: 0.4, animation: 'houseFloat 2s ease infinite',
          }}>
            <div style={{ color: '#fff', fontSize: 24 }}>&#8964;</div>
          </div>
        </div>
      </section>

      {/* ═══ AI HIGHLIGHT BANNER ═══ */}
      <section style={{
        padding: isMobile ? '60px 24px' : '100px 48px',
        background: '#fff',
      }}>
        <div style={{
          maxWidth: 1000, margin: '0 auto',
          background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)',
          borderRadius: 24,
          padding: isMobile ? '40px 24px' : '60px 60px',
          position: 'relative', overflow: 'hidden',
          boxShadow: '0 24px 64px rgba(26,26,46,0.2)',
        }}>
          {/* Glow */}
          <div style={{
            position: 'absolute', top: -50, right: -50,
            width: 200, height: 200, borderRadius: '50%',
            background: 'radial-gradient(circle, rgba(212,165,55,0.2) 0%, transparent 60%)',
          }} />
          <div style={{
            position: 'absolute', bottom: -30, left: -30,
            width: 150, height: 150, borderRadius: '50%',
            background: 'radial-gradient(circle, rgba(232,54,58,0.15) 0%, transparent 60%)',
          }} />

          <div style={{
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            alignItems: 'center', gap: isMobile ? 32 : 48,
            position: 'relative', zIndex: 1,
          }}>
            {/* AI Icon */}
            <div style={{
              width: isMobile ? 80 : 120, height: isMobile ? 80 : 120,
              borderRadius: 24, flexShrink: 0,
              background: 'linear-gradient(135deg, #d4a537, #f0c75e)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: isMobile ? 36 : 48,
              animation: 'houseGlow 3s ease infinite',
            }}>
              <span role="img" aria-label="ai">&#129302;</span>
            </div>

            <div style={{ flex: 1 }}>
              <h2 style={{
                fontSize: isMobile ? 24 : 32, fontWeight: 700,
                color: '#fff', marginBottom: 12,
                letterSpacing: -0.5,
              }}>
                {t.aiTitle}
              </h2>
              <p style={{
                fontSize: isMobile ? 15 : 17, color: 'rgba(255,255,255,0.6)',
                lineHeight: 1.7, marginBottom: 24,
              }}>
                {t.aiDesc}
              </p>
              <button
                onClick={() => navigate(`/h/${slug}/chat`)}
                style={{
                  background: 'rgba(255,255,255,0.1)',
                  border: '1px solid rgba(255,255,255,0.2)',
                  color: '#fff',
                  padding: '14px 32px',
                  borderRadius: 12,
                  fontSize: 15, fontWeight: 600,
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  backdropFilter: 'blur(10px)',
                }}
                onMouseEnter={e => { e.target.style.background = 'rgba(212,165,55,0.2)'; e.target.style.borderColor = 'rgba(212,165,55,0.4)'; }}
                onMouseLeave={e => { e.target.style.background = 'rgba(255,255,255,0.1)'; e.target.style.borderColor = 'rgba(255,255,255,0.2)'; }}
              >
                {t.aiCta} &#8594;
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* ═══ FEATURED PROPERTIES ═══ */}
      <section style={{
        padding: isMobile ? '60px 24px' : '100px 48px',
        background: '#f5f5fa',
      }}>
        <div style={{ maxWidth: 1200, margin: '0 auto' }}>
          <div style={{
            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
            marginBottom: 48,
          }}>
            <div>
              <h2 style={{ fontSize: isMobile ? 28 : 40, fontWeight: 800, color: '#1a1a2e', letterSpacing: -1, marginBottom: 8 }}>
                {t.featured}
              </h2>
              <div style={{ width: 48, height: 4, borderRadius: 2, background: 'linear-gradient(90deg, #e8363a, #d4a537)' }} />
            </div>
            <button
              onClick={() => navigate(`/h/${slug}/properties`)}
              style={{
                background: 'transparent', border: '1px solid rgba(26,26,46,0.15)',
                color: '#1a1a2e', padding: '10px 24px', borderRadius: 12,
                fontSize: 14, fontWeight: 600, cursor: 'pointer',
                transition: 'all 0.3s ease',
              }}
              onMouseEnter={e => { e.target.style.background = '#1a1a2e'; e.target.style.color = '#fff'; }}
              onMouseLeave={e => { e.target.style.background = 'transparent'; e.target.style.color = '#1a1a2e'; }}
            >
              {t.viewAll} &#8594;
            </button>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)',
            gap: 24,
          }}>
            {displayProperties.slice(0, 6).map((prop, idx) => (
              <div
                key={prop.id || idx}
                onClick={() => navigate(`/h/${slug}/property/${prop.id || idx + 1}`)}
                style={{
                  background: '#fff',
                  borderRadius: 20,
                  overflow: 'hidden',
                  cursor: 'pointer',
                  transition: 'all 0.35s ease',
                  boxShadow: '0 4px 24px rgba(0,0,0,0.06)',
                }}
                onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-8px)'; e.currentTarget.style.boxShadow = '0 16px 48px rgba(0,0,0,0.12)'; }}
                onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 4px 24px rgba(0,0,0,0.06)'; }}
              >
                {/* Image */}
                <div style={{
                  height: 220, position: 'relative',
                  background: prop.gradient || gradients[idx % gradients.length],
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                }}>
                  {(prop.images?.[0]) ? (
                    <img
                      src={prop.images[0].includes('picsum.photos') ? `${API_BASE}/h/${slug}/img-proxy?url=${encodeURIComponent(prop.images[0])}` : prop.images[0]}
                      alt={prop.title}
                      onError={e => { e.target.style.display = 'none'; }}
                      style={{ width: '100%', height: '100%', objectFit: 'cover', position: 'absolute', inset: 0 }}
                    />
                  ) : (
                    <span style={{ fontSize: 48, opacity: 0.3 }}>&#127963;</span>
                  )}
                  {/* Price Overlay */}
                  <div style={{
                    position: 'absolute', bottom: 16, left: 16,
                    background: 'rgba(0,0,0,0.65)', backdropFilter: 'blur(10px)',
                    borderRadius: 10, padding: '8px 16px',
                    color: '#fff', fontSize: 18, fontWeight: 700,
                    letterSpacing: -0.3,
                  }}>
                    {formatPrice(prop.price, prop.currency)}
                  </div>
                  {/* HOT Badge */}
                  {prop.is_featured && (
                    <div style={{
                      position: 'absolute', top: 16, right: 16,
                      background: 'linear-gradient(135deg, #e8363a, #c02a2e)',
                      color: '#fff', fontSize: 11, fontWeight: 700,
                      padding: '4px 12px', borderRadius: 8,
                      letterSpacing: 1,
                    }}>
                      {t.hot}
                    </div>
                  )}
                </div>

                {/* Info */}
                <div style={{ padding: '20px 20px 24px' }}>
                  <h3 style={{ fontSize: 17, fontWeight: 700, color: '#1a1a2e', marginBottom: 8, lineHeight: 1.3 }}>
                    {prop.title}
                  </h3>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 16, color: '#888', fontSize: 14 }}>
                    <span>&#128205;</span> {prop.location || prop.district}
                  </div>
                  <div style={{ display: 'flex', gap: 16 }}>
                    {[
                      { icon: '\ud83d\udecf\ufe0f', val: `${prop.bedrooms} ${t.beds}` },
                      { icon: '\ud83d\udebf', val: `${prop.bathrooms} ${t.baths}` },
                      { icon: '\u25a1', val: `${prop.area_sqm} ${t.sqm}` },
                    ].map((spec, i) => (
                      <span key={i} style={{
                        background: '#f5f5fa', borderRadius: 8, padding: '4px 10px',
                        fontSize: 12, color: '#666', fontWeight: 500,
                        display: 'flex', alignItems: 'center', gap: 4,
                      }}>
                        {spec.icon} {spec.val}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ═══ HOW IT WORKS ═══ */}
      <section style={{
        padding: isMobile ? '60px 24px' : '100px 48px',
        background: '#fff',
      }}>
        <div style={{ maxWidth: 1100, margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: 64 }}>
            <h2 style={{ fontSize: isMobile ? 28 : 40, fontWeight: 800, color: '#1a1a2e', letterSpacing: -1, marginBottom: 12 }}>
              {t.howTitle}
            </h2>
            <div style={{ width: 48, height: 4, borderRadius: 2, background: 'linear-gradient(90deg, #e8363a, #d4a537)', margin: '0 auto' }} />
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: isMobile ? '1fr' : 'repeat(4, 1fr)',
            gap: 32,
          }}>
            {[
              { icon: '\ud83d\udcac', title: t.step1t, desc: t.step1d, color: '#667eea' },
              { icon: '\ud83c\udfaf', title: t.step2t, desc: t.step2d, color: '#f5576c' },
              { icon: '\ud83c\udfac', title: t.step3t, desc: t.step3d, color: '#4facfe' },
              { icon: '\ud83e\udd1d', title: t.step4t, desc: t.step4d, color: '#43e97b' },
            ].map((step, i) => (
              <div key={i} style={{ textAlign: 'center', position: 'relative' }}>
                {/* Connector line (desktop) */}
                {!isMobile && i < 3 && (
                  <div style={{
                    position: 'absolute', top: 40, left: '60%', width: '80%',
                    height: 2, background: 'linear-gradient(90deg, rgba(26,26,46,0.1), rgba(26,26,46,0.05))',
                    zIndex: 0,
                  }} />
                )}

                <div style={{
                  width: 80, height: 80, borderRadius: 24, margin: '0 auto 20px',
                  background: `linear-gradient(135deg, ${step.color}15, ${step.color}08)`,
                  border: `1px solid ${step.color}20`,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: 32, position: 'relative', zIndex: 1,
                }}>
                  {step.icon}
                </div>
                <div style={{
                  background: '#1a1a2e', color: '#fff',
                  width: 28, height: 28, borderRadius: '50%',
                  display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: 13, fontWeight: 700, marginBottom: 16,
                }}>
                  {i + 1}
                </div>
                <h3 style={{ fontSize: 17, fontWeight: 700, color: '#1a1a2e', marginBottom: 8 }}>{step.title}</h3>
                <p style={{ fontSize: 14, color: '#888', lineHeight: 1.7 }}>{step.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ═══ STATS BAR ═══ */}
      <section style={{
        padding: isMobile ? '48px 24px' : '64px 48px',
        background: 'linear-gradient(135deg, #1a1a2e 0%, #0f3460 100%)',
      }}>
        <div style={{
          maxWidth: 1000, margin: '0 auto',
          display: 'grid',
          gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)',
          gap: isMobile ? 32 : 48,
          textAlign: 'center',
        }}>
          {[
            { num: 40000, suffix: '+', label: t.statsProperties },
            { num: 500, suffix: '+', label: t.statsClients },
            { num: 24, suffix: '/7', label: t.statsSupport },
            { num: 15, suffix: '', label: t.statsLang },
          ].map((stat, i) => (
            <div key={i}>
              <div style={{
                fontSize: isMobile ? 32 : 44, fontWeight: 800, color: '#d4a537',
                marginBottom: 8, letterSpacing: -1,
              }}>
                <AnimatedCounter end={stat.num} suffix={stat.suffix} />
              </div>
              <div style={{ fontSize: 14, color: 'rgba(255,255,255,0.5)', fontWeight: 500, letterSpacing: 0.5 }}>
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ═══ TESTIMONIALS ═══ */}
      <section style={{
        padding: isMobile ? '60px 24px' : '100px 48px',
        background: '#f5f5fa',
      }}>
        <div style={{ maxWidth: 1100, margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: 56 }}>
            <h2 style={{ fontSize: isMobile ? 28 : 40, fontWeight: 800, color: '#1a1a2e', letterSpacing: -1, marginBottom: 12 }}>
              {t.testTitle}
            </h2>
            <div style={{ width: 48, height: 4, borderRadius: 2, background: 'linear-gradient(90deg, #e8363a, #d4a537)', margin: '0 auto' }} />
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)',
            gap: 24,
          }}>
            {TESTIMONIALS.map((test, i) => (
              <div key={i} style={{
                background: '#fff', borderRadius: 20, padding: 32,
                boxShadow: '0 4px 24px rgba(0,0,0,0.04)',
                position: 'relative',
                transition: 'all 0.3s ease',
              }}
              onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.boxShadow = '0 12px 36px rgba(0,0,0,0.08)'; }}
              onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 4px 24px rgba(0,0,0,0.04)'; }}
              >
                {/* Quote mark */}
                <div style={{ position: 'absolute', top: 20, right: 24, fontSize: 48, color: 'rgba(212,165,55,0.15)', fontFamily: 'Georgia', lineHeight: 1 }}>"</div>

                <div style={{ display: 'flex', gap: 4, marginBottom: 16 }}>
                  {Array(test.rating).fill(0).map((_, j) => (
                    <span key={j} style={{ color: '#d4a537', fontSize: 16 }}>&#9733;</span>
                  ))}
                </div>

                <p style={{ fontSize: 15, color: '#555', lineHeight: 1.7, marginBottom: 24, fontStyle: 'italic' }}>
                  "{test.text}"
                </p>

                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                  <div style={{
                    width: 44, height: 44, borderRadius: '50%',
                    background: gradients[i % gradients.length],
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    color: '#fff', fontWeight: 700, fontSize: 16,
                  }}>
                    {test.name[0]}
                  </div>
                  <div>
                    <div style={{ fontWeight: 700, color: '#1a1a2e', fontSize: 15 }}>{test.name}</div>
                    <div style={{ color: '#999', fontSize: 13 }}>{test.role}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ═══ CTA / INQUIRY FORM ═══ */}
      <section style={{
        padding: isMobile ? '60px 24px' : '100px 48px',
        background: '#fff',
      }}>
        <div style={{
          maxWidth: 640, margin: '0 auto',
          textAlign: 'center',
        }}>
          <h2 style={{
            fontSize: isMobile ? 28 : 40, fontWeight: 800,
            color: '#1a1a2e', letterSpacing: -1, marginBottom: 12,
          }}>
            {t.ctaTitle}
          </h2>
          <p style={{ fontSize: 16, color: '#888', marginBottom: 40, lineHeight: 1.7 }}>
            {t.ctaSub}
          </p>

          <div style={{ textAlign: 'left', display: 'flex', flexDirection: 'column', gap: 16 }}>
            {[
              { key: 'name', placeholder: t.name, type: 'text' },
              { key: 'email', placeholder: t.email, type: 'email' },
              { key: 'phone', placeholder: t.phone, type: 'tel' },
            ].map(field => (
              <input
                key={field.key}
                type={field.type}
                placeholder={field.placeholder}
                value={formData[field.key]}
                onChange={e => setFormData(prev => ({ ...prev, [field.key]: e.target.value }))}
                style={{
                  width: '100%', padding: '16px 20px',
                  borderRadius: 14,
                  border: '1px solid rgba(26,26,46,0.1)',
                  background: '#f5f5fa',
                  fontSize: 15, outline: 'none',
                  transition: 'all 0.2s',
                }}
                onFocus={e => { e.target.style.borderColor = '#d4a537'; e.target.style.background = '#fff'; }}
                onBlur={e => { e.target.style.borderColor = 'rgba(26,26,46,0.1)'; e.target.style.background = '#f5f5fa'; }}
              />
            ))}

            <textarea
              placeholder={t.message}
              value={formData.message}
              onChange={e => setFormData(prev => ({ ...prev, message: e.target.value }))}
              rows={4}
              style={{
                width: '100%', padding: '16px 20px',
                borderRadius: 14,
                border: '1px solid rgba(26,26,46,0.1)',
                background: '#f5f5fa',
                fontSize: 15, outline: 'none',
                resize: 'vertical',
                fontFamily: 'inherit',
                transition: 'all 0.2s',
              }}
              onFocus={e => { e.target.style.borderColor = '#d4a537'; e.target.style.background = '#fff'; }}
              onBlur={e => { e.target.style.borderColor = 'rgba(26,26,46,0.1)'; e.target.style.background = '#f5f5fa'; }}
            />

            <button
              onClick={handleFormSubmit}
              style={{
                width: '100%',
                background: formSubmitted ? 'linear-gradient(135deg, #43e97b, #38f9d7)' : 'linear-gradient(135deg, #e8363a, #c02a2e)',
                color: '#fff', border: 'none',
                padding: '18px', borderRadius: 14,
                fontSize: 16, fontWeight: 700,
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                boxShadow: formSubmitted ? '0 4px 16px rgba(67,233,123,0.3)' : '0 4px 16px rgba(232,54,58,0.3)',
                letterSpacing: 0.5,
              }}
              onMouseEnter={e => { if (!formSubmitted) { e.target.style.transform = 'translateY(-2px)'; e.target.style.boxShadow = '0 8px 24px rgba(232,54,58,0.4)'; } }}
              onMouseLeave={e => { e.target.style.transform = 'translateY(0)'; e.target.style.boxShadow = formSubmitted ? '0 4px 16px rgba(67,233,123,0.3)' : '0 4px 16px rgba(232,54,58,0.3)'; }}
            >
              {formSubmitted ? '&#10003; Sent!' : t.submit}
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}
